/* Header: Course Catalog mega menu (desktop hover/click, mobile accordion). */
(function () {
  'use strict';
  var DESKTOP = window.matchMedia('(min-width: 1201px)');

  function init(root) {
    var item = root.querySelector('[data-mega-item]');
    if (!item) return;
    var trigger = item.querySelector('[data-mega-trigger]');
    var closeTimer;

    function setOpen(open) {
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!item.classList.contains('is-open'));
    });

    // Desktop: open on hover with a small close delay so the pointer can travel to the panel.
    item.addEventListener('mouseenter', function () {
      if (!DESKTOP.matches) return;
      clearTimeout(closeTimer);
      setOpen(true);
    });
    item.addEventListener('mouseleave', function () {
      if (!DESKTOP.matches) return;
      closeTimer = setTimeout(function () { setOpen(false); }, 150);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { setOpen(false); trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (DESKTOP.matches && !item.contains(e.target)) setOpen(false);
    });

    // Mobile: each category is an accordion.
    root.querySelectorAll('.cs-mega__cat').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (DESKTOP.matches) return;
        var col = btn.closest('.cs-mega__col');
        var open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    DESKTOP.addEventListener('change', function () { setOpen(false); });
  }

  function boot() { document.querySelectorAll('.cs-header').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('.cs-header')) init(e.target); });
})();
